module.exports = __webpack_public_path__ + "img/news-img.4634ad3.png";